export default "/videos/916b269468cc00212fb000b02bc8674c.mp4";